module.exports = __webpack_public_path__ + "img/warn.4248b383.svg";